import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import swal from 'sweetalert';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {Table, Button} from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';
import {search} from 'react-icons-kit/icomoon/search';
import RaisedButton from 'material-ui/RaisedButton';
import Help from '../generics/help';
import ModalPersonSearch from '../generics/modal_person_search';

var Config = require('../../config');
const style = {
  margin: 12,
};

class Fusion extends Component{
	constructor(props){
		super(props);

		this.searchDonor = this.searchDonor.bind(this);
		this.searchPatient = this.searchPatient.bind(this);
		this.getList = this.getList.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.person_search = this.person_search.bind(this);

		this.state = {
			fusion_type:"",

			persons:[],
			load_person:false,
			person_selected:[],
			index_person:-1,

			results:[],
			actions:[{name:'MANTENER', value:'PRINCIPAL'}, {name:'FUSIONAR', value:'DELETE'}, {name:'NO PROCESAR', value:'NOPROCESS'}],
			documents:[],
			columns:[]
		}
	}

	componentDidMount(){
		var path = this.props.match.path.split('/');
		this.setState({fusion_type: path[2]});

		

		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({documents:response});
			}
		});

		this.getColumns();

	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	componentDidUpdate(){
		var path = this.props.match.path.split('/');
		if(this.state.fusion_type !== path[2]){
			this.setState({
				fusion_type: path[2],
				persons:[],
				load_person:false,
				person_selected:[],
				index_person:-1,
				results:[],
			});
			this._typeahead.getInstance().clear();
			//this._typeahead.getInstance().focus();
			this.getColumns();
		}
	}

	getColumns(){
		var path = this.props.match.path.split('/');
		var key_search = path[2] === 'donor' ? 'FUSION_DONORS' : 'PATIENT_FUSION';
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search='+key_search,{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		this.props.waiting.handleClose();
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});
	}

	_handleSearch = (query)=>{
		if(query !== undefined){
			this.setState({load_person:true});
			if(this.state.fusion_type === 'donor'){
				this.searchDonor(query);
			}else{
				this.searchPatient(query);
			}
		}
	}

	searchDonor(query){
		fetch(Config.default.apiGateway.URL+'donors?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null  && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}

					if(response[i].document !== null){							
						response[i].names +=' '+response[i].document_type_value;
						response[i].names +=' '+response[i].document_number;
						
					}
					response[i].id = response[i].donor_id;


				};

				this.state.results.map((res)=>{
					var index = response.findIndex(obj => 
						obj.person_id === res.id
					)

					if(index !== -1){
						response.splice(index, 1);
					}
				})
				
				setTimeout(()=>{
					this.setState({
						load_person: false,
				     	persons: response
				    });

				    setTimeout(()=>{
				    	if(this.modal_person_search.state.show){
				    		var id = '';
				    		this.modal_person_search.state.list.map((p)=>{
				    			if(p.check){
				    				id = p.person_id;
				    			}
				    		});

				    		var index = this.state.persons.findIndex(obj => 
				    			 parseInt(obj.person_id) === parseInt(id)
				    		);

				    		if(index !== -1){
				    			this.getList([this.state.persons[index]]);
				    			this.modal_person_search.handleClose();
				    			this.props.waiting.handleClose();
				    		}else{
				    			swal('Información', 'El donador seleccionado ya se encuentra en el listado', 'info')
				    			this.modal_person_search.handleClose();
				    			this.props.waiting.handleClose();
				    		}
				    	}
				    	
				    }, 500);
				}, 1000);
			}
		})
	}

	searchPatient(query){
		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null  && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}

					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}

					response[i].id = response[i].person_id;


				};

				this.state.results.map((res)=>{
					var index = response.findIndex(obj => 
						obj.id === res.id
					)

					if(index !== -1){
						response.splice(index, 1);
					}
				})
				setTimeout(()=>{
					this.setState({
						load_person: false,
				     	persons: response
				    });

				    setTimeout(()=>{
				    	if(this.modal_person_search.state.show){
				    		var id = '';
				    		this.modal_person_search.state.list.map((p)=>{
				    			if(p.check){
				    				id = p.person_id;
				    			}
				    		});

				    		var index = this.state.persons.findIndex(obj => 
				    			 parseInt(obj.id) === parseInt(id)
				    		);

				    		if(index !== -1){
				    			this.getList([this.state.persons[index]]);
				    			this.modal_person_search.handleClose();
				    			this.props.waiting.handleClose();
				    		}else{
				    			swal('Información', 'El paciente seleccionado ya se encuentra en el listado', 'info');
				    			this.modal_person_search.handleClose();
				    			this.props.waiting.handleClose();
				    		}
				    	}
				    	
				    }, 500);
				}, 1000);
					
			}
		})
	}

	getList(e){
		if(e.length > 0){
			var id = this.state.fusion_type === 'donor' ?  e[0].person_id : e[0].person_id;
			var url = this.state.fusion_type === 'donor' ?
						'person/coincidences?id='+id+'&type=DONOR'
					: 'person/coincidences?id='+id+'&type=PATIENT';

			//this.setState({results:[]});

			fetch(Config.default.apiGateway.URL+url, {
				method:'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){

					var results = this.state.results;
					var encontrado = false;
					response.map((r)=>{
						r.document_type = '';
						if(r.document !== null){
							var index = this.state.documents.findIndex(obj => 
								obj.key === r.document.document_type
							);
							if(index !== -1){
								r.document_type = this.state.documents[index].name
							}
						}
						var phenotypes = '';
						r.phenotype.map((p, i)=>{
							phenotypes += p+(i === r.phenotype.length -1 ? '' : ', ')
						});
						r.action = 'NOPROCESS';
						r.disable_action = false;

						var index = this.state.results.findIndex(obj => 
							obj.id === r.id
						);

						if(index !== -1){
							encontrado = true;
						}else{
							results.push(r);

							
							var index = this.state.persons.findIndex(obj =>
								 obj.person_id === r.id
							)

							if(index !== -1){
								this.state.persons.splice(index, 1);
								this.forceUpdate();
							}
						}
						
					})

					if(!encontrado){
						this.setState({
							results:results
						});
						this._typeahead.getInstance().clear();
						this._typeahead.getInstance().focus();
					}else{
						swal('Error', 'El Registro que intenta agregar ya se encuentra en la tabla', 'error');
					}
						
				}
			})

		}
		//api/person/coincidences?id={person_id}&type={DONOR o PATIENT}
	}

	handleChange(e, i){
		var valor = e.target.value;
		var index = this.state.results.findIndex(obj => 
			obj.action === valor && valor === 'PRINCIPAL'
		);

		if(index === -1){
			this.state.results[i].action = e.target.value;
			this.state.results.map((r, j)=>{
				if(j === i){
					this.state.results[i].action = valor;

					r.disable_action = false;
				}else{
					if(valor === 'PRINCIPAL'){
						r.disable_action = true;
					}else{
						r.disable_action = false;
					}
				}
			})
			this.forceUpdate();
		}		
	}

	onDelete(e, i){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm) => {
	        if (isConfirm) {
	          	var array = [...this.state.results];
				array.splice(i, 1);
				this.setState({results: array});
	        }
	    });
	}

	onSave(force){
		var url = 'person/fusion/'+(this.state.fusion_type === 'donor' ? 'DONOR' : 'PATIENT')+'/'+force;

		var obj = [];
		var principal = false;
		this.state.results.map((r)=>{
			if(r.action !== ''){
				obj.push({
					id: r.id,
					action: r.action
				});

				if(r.action === 'PRINCIPAL'){
					principal = true;
				}
			}
		});

		if(principal){
			if(obj.length === this.state.results.length){
				this.props.waiting.handleShow('Fusionando...');
				fetch(Config.default.apiGateway.URL+url, {
					method:'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						
						if(response.length > 0){
							var error = '';
							response.map((res, i)=>{
								var discrepacias = res.action.split('|');
								var indice = this.state.results.findIndex(obj => 
									obj.id === res.id
								);
								error += 'Registro '+(indice+1)+'\n'
								if(discrepacias.length > 0){
									discrepacias.map((d)=>{
										error += '-- '+d+'\n'
									})
								}else{
									error += '-- '+res.action+'\n'
								}
									
								
							});
							//swal('Error', error, 'error');
							swal({
						        title: '¿Desea Continuar?',
						        text: error,
						        type: 'error',
						        showCancelButton: true,
						        confirmButtonColor: '#DD6B55',
						        confirmButtonText: '¡Si, Fusionar!',
						        cancelButtonText: '¡No, Cancelar!',
						        closeOnConfirm: true,
						        closeOnCancel: true
						    }, (isConfirm) => {
						        if (isConfirm) {
						          	this.onSave('true');
						        }
						    });
						}else{
							swal('Correcto', 'La fusión se realizo correctamente.', 'success');
							this.setState({
								persons:[],
								load_person:false,
								person_selected:[],
								index_person:-1,
								results:[],
							});
							this._typeahead.getInstance().clear();
							this._typeahead.getInstance().focus();
						}
					}
				})

				
			}else{
				swal('Error', 'Existen elementos sin una acción', 'error');
			}
		}else{
			swal('Error', 'Debe seleccionar un elemento como principal', 'error');
		}

	}
	onCancel(){
		this.props.history.push('/');
	}

	person_search(){
		if(this.state.fusion_type === 'donor'){
			this.modal_person_search.handleShow('Donador','donors');	
		}else{
			this.modal_person_search.handleShow('Paciente','patients');
		}
		
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');
		var action = this.props.match.path.indexOf('patient') !== -1 ? 'ACTION' : 'CONTROLS';

		return (
			<div className="col-xs-12">
	          	<div className="route">
	            	<h5 className="title_page" >
	              	{session} ->
	              	{this.state.fusion_type === 'donor' ? t('sidebar.nav.donors.MAIN') : t('sidebar.nav.patients.MAIN')} -> 
	              	{this.state.fusion_type === 'donor' ? 'Fusión Donantes' : 'Fusión Pacientes'}
	            	</h5>
	          	</div>

	          	<Help
					{...this.props} 
	                menu={this.state.fusion_type === 'donor' ? "help_donors" : "help_patients"} 
	                submenu={this.state.fusion_type === 'donor' ? "help_fusion_donors" : "help_patient_fusion"}  />

	          	<div className="col-xs-12 form-group">
	          		<div className="col-xs-12 col-sm-5" style={{paddingRight:"0px"}}>
	          			<span className="span-min">
	          				{this.state.fusion_type === 'donor' ? 'Buscar Donantes' : 'Buscar Pacientes'}
	          			</span>
						<AsyncTypeahead
				          	labelKey={(option) => `${option.names}`}
				          	minLength={0}
				          	options={this.state.persons}
				          	onSearch={this._handleSearch}
				          	onChange={this.getList}
				          	name="person_id"
				          	id="person_id"
				          	isLoading={this.state.load_person}
				          	reuired={true}
				          	placeholder="Buscar por apellidos más nombre o número de documento..."
				          	ref={ref => this._typeahead = ref}
				          	useCache={false}
				          	delay={600}
				          	paginationText="Mostrar mas resultados..."
				        />
					</div>

					<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
						<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
							onClick={this.person_search}/>
					</div>
					
	          	</div>
	          	<hr style={{width:'100%'}} />
	          	<div className="col-xs-12 form-group">
	          		<Table responsive hover>
	          			<thead>
	          				<tr>
	          					<th></th>
	          					<th hidden={this.showColumn('LASTNAME1')}>A. Paterno</th>
	          					<th hidden={this.showColumn('LASTNAME2')}>A. Materno</th>
	          					<th hidden={this.showColumn('NAMES')}>Nombre(s)</th>
	          					{action === 'ACTION' ? <th>No. Expediente</th> : null}
	          					<th hidden={this.showColumn('BIRTHDAY')}>F. Nacimiento</th>
	          					{action === 'CONTROLS' ? <th hidden={this.showColumn('DOCUMENT')}>T. Identificación</th> : null}
	          					{action === 'CONTROLS' ? <th hidden={this.showColumn('DOCUMENT_NUMBER')}>No. Identificación</th> : null}
	          					<th hidden={this.showColumn('GROUP_RH')}>Grupo & RH</th>
	          					<th hidden={this.showColumn('PHENOTYPES')}>Fenotipos</th>
	          					<th hidden={this.showColumn(action)}>Acción</th>
	          				</tr>
	          			</thead>
	          			<tbody>
	          				{this.state.results.map((r, i)=>(
	          					<tr key={i}>
	          						<td>{i+1}</td>
	          						<td hidden={this.showColumn('LASTNAME1')}>{r.lastname1}</td>
		          					<td hidden={this.showColumn('LASTNAME2')}>{r.lastname2}</td>
		          					<td hidden={this.showColumn('NAMES')}>{r.names}</td>
		          					{action === 'ACTION' ? <td>{r.number}</td> : null}
		          					<td hidden={this.showColumn('BIRTHDAY')}>{r.birthday !== null ? moment(r.birthday).format('DD/MM/YYYY') : ''}</td>
		          					{action === 'CONTROLS' ? <td hidden={this.showColumn('DOCUMENT')}>{r.document_type}</td> : null}
		          					{action === 'CONTROLS' ? <td hidden={this.showColumn('DOCUMENT_NUMBER')}>{r.document !== null ? r.document.document_number : ''}</td> : null}
		          					<td hidden={this.showColumn('GROUP_RH')}>
		          						{(r.lookup_group !== null ? r.lookup_group : '')+
		          						(r.lookup_rh === 'POSITIVO' ? '+' :
		          						 r.lookup_rh === 'NEGATIVO' ? '-' : '')}
		          					</td>
		          					<td hidden={this.showColumn('PHENOTYPES')}>{r.phenotypes}</td>
		          					<td hidden={this.showColumn(action)}>
		          						<select className="form-control" value={r.action} onChange={(e)=>this.handleChange(e, i)}>
		          							<option value="">Seleccione...</option>
		          							{this.state.actions.map((a, j)=>(
		          								<option key={j} value={a.value} disabled={a.value === 'PRINCIPAL' && a.disable_action}>
		          									{a.name}
		          								</option>
		          							))}
		          						</select>
		          					</td>
		          					{/*<td>
		          						<Button className="btn btn-info btn-xs" title="Eliminar" 
		          							style={{marginRight:"5px"}}
											onClick={(e)=>this.onDelete(e, i)} >
											<SvgIcon icon={bin} />
										</Button>
									  </td>*/}
	          					</tr>
	          				))}
	          			</tbody>
	          		</Table>
	          	</div>

	          	<div className="col-xs-12" style={{textAlign:'center'}}>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
	        			onClick={this.onSave.bind(this, 'false')} style={style}/>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
	        			onClick={this.onCancel} style={style}/>
		        	
		        </div>

		        <ModalPersonSearch {...this.props} 
		        	waiting={this.props.waiting} 
		        	updatePerson={this.getList} 
		        	onRef={ref => (this.modal_person_search = ref)} 
		        	search={this.getList}
		        	persons={this.state.persons}
		        />
	        </div>
		)
	}
}

export default translate('translations')(Fusion)